// useMeta.ts
import { useEffect } from 'react';

interface MetaOptions {
  title?: string;
  description?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  // Add more meta tags as needed
}

const useMeta = (options: MetaOptions) => {
  useEffect(() => {
    const {
      title,
      description,
      canonical,
      ogTitle,
      ogDescription,
      ogImage,
      ogUrl,
      twitterCard,
      twitterTitle,
      twitterDescription,
      twitterImage,
    } = options;

    if (typeof title === 'string' && title.trim() !== '') {
      document.title = title.trim();
    }

    const metaTags = [
      { name: 'description', content: description },
      { property: 'og:title', content: ogTitle },
      { property: 'og:description', content: ogDescription },
      { property: 'og:image', content: ogImage },
      { property: 'og:url', content: ogUrl },
      { name: 'twitter:card', content: twitterCard },
      { name: 'twitter:title', content: twitterTitle },
      { name: 'twitter:description', content: twitterDescription },
      { name: 'twitter:image', content: twitterImage },
    ];

    metaTags.forEach(({ name, property, content }) => {
      if (typeof content === 'string' && content.trim() !== '') {
        let metaTag = document.querySelector(
          `meta${name ? `[name="${name}"]` : `[property="${property}"]`}`,
        );

        if (!metaTag) {
          metaTag = document.createElement('meta');
          if (name) {
            metaTag.setAttribute('name', name);
          } else {
            metaTag.setAttribute('property', property || '');
          }
          document.head.appendChild(metaTag);
        }

        metaTag.setAttribute('content', content.trim());
      }
    });

    if (typeof canonical === 'string' && canonical.trim() !== '') {
      let linkTag = document.querySelector('link[rel="canonical"]');

      if (!linkTag) {
        linkTag = document.createElement('link');
        linkTag.setAttribute('rel', 'canonical');
        document.head.appendChild(linkTag);
      }

      linkTag.setAttribute('href', canonical.trim());
    }
  }, [options]);
};

export default useMeta;
